import React from 'react'
import './WeldAnalysis.css'
import { faEdit, faClock, faCheckCircle, faChartLine, faChartBar, faBed, faCut } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function AnalycticTable(props) {


  return (
<>

    <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12" onClick={props.onClick}>
               <div className={`info-box-small bg-${props.bg}`}>
                  <span className="info-box-icon">
                            <FontAwesomeIcon
                                style={{ float: "center" }}
                                icon={props.icon}
                            />
                    </span>
                  <div className="info-box-content">
                     <span className="info-box-text">{props.title}</span>
                     <br/>
                     <br/>
                     <span className="info-box-text"><span id="availDen"></span><span style={{ float : "right"}} id="totalAvailableTime">{props.resultValue ? props.resultValue : "Value not found"}</span></span>
                     <br/>
                     <br/>
                     {/* <span className="info-box-number"> <span id="availabilityOEE">-</span></span> */}
                  </div>
               </div>
            </div>

</>
  )
}
